import { faker } from '@faker-js/faker'

import { BookingMethods } from '../../contracts/appointment/bookingMethods'
import { asBuilder } from '../asBuilder'

export const getBookingMethods = asBuilder<BookingMethods>((): BookingMethods => {
  const isReservableWithSchedule = faker.datatype.boolean()
  return {
    isPurchasable: faker.datatype.boolean(),
    isLoyaltyPointRedeemableOffline: faker.datatype.boolean(),
    isChatApplicable: faker.datatype.boolean(),
    isPhoneCallApplicable: faker.datatype.boolean(),
    isReservableViaHospitalWebsite: faker.datatype.boolean(),
    isConsultationApplicable: faker.datatype.boolean(),
    isReservableWithSchedule,
    reservationType: isReservableWithSchedule ? faker.helpers.arrayElement(['IMMEDIATE', 'WAITING']) : null,
  }
})
